import React from "react";

const ServerStorageIcon = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Cuerpo principal del servidor */}
    <rect x="3" y="10" width="18" height="7" rx="2" ry="2" />
    {/* Tapa superior curva un poco más grande */}
    <path d="M4 10 Q12 4 20 10" />
    {/* Luz indicadora izquierda */}
    <circle cx="7.5" cy="13.5" r="1" fill={color} stroke="none" />
    {/* Ranura decorativa */}
    <line x1="10.5" y1="13.5" x2="16.5" y2="13.5" />
  </svg>
);

export default ServerStorageIcon